var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","min-height":"700px"},attrs:{"src":"http://43.153.108.9:8088/chatbot/yHaFqaIBiJpXC25U","frameborder":"0","allow":"microphone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }